


















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import EstimateStatus from "@/usecases/orders/estimate-status";

@Component({})
export default class EstimateContractDateModal extends Vue {
  @Prop({ required: true }) estimateId!: string;
  @Prop({ required: true }) contractDateInit!: string;

  contractDate: string = "";

  @Watch("contractDateInit", { immediate: true })
  changeDateInit(value: string) {
    this.contractDate = value;
  }

  show() {
    (this.$refs.modal as any).show();
  }

  hide() {
    (this.$refs.modal as any).hide();
  }

  create() {
    this.$emit(
      "ok",
      this.estimateId,
      EstimateStatus.Success,
      this.contractDate
    );
    this.hide();
  }
}
